import { ApiPrefixV1, ApiV1Base } from 'util/icwUtility';

const MICRO_PREFIX = `${ApiV1Base}${ApiPrefixV1}/micro`;
export const MICRO_RESOURCES = [
  {
    name: 'service-providers',
  },
  {
    name: 'suppliers',
  },
  // #region Document Lists
  {
    name: 'document-list',
  },
  {
    name: 'document-list/types',
  },
  {
    name: 'document-list/document-list-index',
  },
  // #endregion Document Lists

  // #region Third Party
  {
    name: 'third-party_inspections_report',
    list: '/third-party/inspections/:id/reports',
    descriptions: "Third Party's Inspection Reports",
  },
  // #endregion Third Party

  // #region Product Testing Resource
  {
    // Download All Attachement in Product=Testing
    name: 'product_testing_download_attachments',
    download: '/product-testings/:id/attachments/download',
  },
  // #endregion Product Testing Resource
].map((resource) => {
  return {
    ...resource,
    meta: {
      ...resource.meta,
      apiPrefix: MICRO_PREFIX,
    },
  };
});
